<template>
  <div style="display: contents;">
    <meal
      v-for="(meal,mealIndex) in meals"
      :key="'m' + mealIndex"
      :meal="meal"
      :category="category"
      :result="result"
      :transport="transport"
      :fees="fees"
      :starRating="starRating"
      @priceDetails="$emit('priceDetails', {meal: meal})"
      @book="$emit('book',{ mealIndex })"
      ></meal>
  </div>
</template>

<script>
import meal from './meal_info'

export default {
  props: {
    result: {
      type: Object
    },
    category: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    transport: {
      type: String
    },
    starRating: {
      type: Number,
      default: 0
    },
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  components: { meal },
  computed: {
    meals () {
      return (this.collapsed || !this.showCollapse) ? this.category.meals : this.category.meals.slice(0, 1)
    }
  }
}
</script>
